export default "__VITE_ASSET__Bsb06n2a__"